import React, { useState, useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { HRM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import Loader from "../../../components/ui/Loader/Loader";
import Status from "../../../components/ui/Status";
import DateService from "../../../services/DateService";
import TapHelper from "../../../services/TapHelper";
import { DisplayListPagination } from "../../../components/TapUi";

const EmployeeComplianceEventListModal = ({ isOpen, selectedDate, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [meta, setMeta] = useState({});
    const accessToken = useSelector(state => state.auth.access_token);

    useEffect(() => {
        if (isOpen && selectedDate) {
            fetchEmployeeComplianceDetails();
        }
    }, [isOpen, selectedDate]);

    const fetchEmployeeComplianceDetails = async (page = 1) => {
        setLoading(true);
        try {
            const headers = { 'Authorization': 'Bearer ' + accessToken };

            const params = {
                search_date_from: selectedDate,
                search_date_to: selectedDate,
                per_page: 20,
                page: page,
                need_employee: "Y",
                action: "data"
            };
            const response = await api.server2Api.get(`${HRM_API_BASE_URL_2}/report/compliance-due-date`, {
                params, headers
            });
            const responseData = response.data || {};
            setMeta(
                TapHelper.pick(responseData, [
                    'from',
                    'to',
                    'total',
                    'last_page',
                    'per_page',
                    'current_page'
                ])
            );

            setEvents(responseData.data || []);
        } catch (error) {
            toast.error('Failed to load Employee Compliance details');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show d-block">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Employee Compliance for {DateService.dateFormat(selectedDate, 'DD MMM YYYY')}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <div className="modal-body">
                            {loading ? (
                                <div className="text-center py-3"><Loader /></div>
                            ) : (
                                <table className="table table-bordered table-sm align-middle bg-white mt-2">
                                    <thead className="align-middle table-secondary">
                                        <tr>
                                            <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                            <th scope="col" style={{ width: "20%" }}>Employee</th>
                                            <th scope="col" style={{ width: "15%" }}>Site Name</th>
                                            <th scope="col" style={{ width: "15%" }}>Compliance Name</th>
                                            <th scope="col" style={{ width: "12%" }} className="text-center">Number</th>
                                            <th scope="col" style={{ width: "12%" }}>Due Date</th>
                                            <th scope="col" style={{ width: "12%" }} className="text-center">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {events.length > 0 ? (
                                            events.map((event, index) => (
                                                <tr key={event.id || index}>
                                                    <td className='text-center'>
                                                        {((meta.current_page - 1) * meta.per_page) + index + 1}
                                                    </td>
                                                    <td>{event.display_full_name || '-'}</td>
                                                    <td>{event.site_name || '-'}</td>
                                                    <td>{event.compliance_type || '-'}</td>
                                                    <td className='text-center'>
                                                        {event.number || '-'}
                                                    </td>
                                                    <td>{event.validity_date_display || event?.expiry_date_display || '-'}</td>
                                                    <td className='text-center'>
                                                        <Status color={event.status?.status_color_code}>
                                                            {event.status?.status_text}
                                                        </Status>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="text-center" colSpan={7}>No Record Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                            {events.length > 0 && (
                                <DisplayListPagination
                                    meta={meta}
                                    onPageChange={(e) => fetchEmployeeComplianceDetails(e.selected + 1)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeComplianceEventListModal;